// FIXME not a stable/supported API
export const hovering = url => window.___loader.hovering(url);
